import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalCloseButton, ModalTitle } from "@air/primitive-modal";
import { Tabs } from "@air/primitive-tabs";
import { memo, useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { AnnotationsShortcutsInfo } from "~/components/AssetModal/Panel/Tabs/KeyboardShortcutsInfoButton/KeyboardShortcutsInfoModal/components/AnnotationsShortcutsInfo";
import { BasicShortcutsInfo } from "~/components/AssetModal/Panel/Tabs/KeyboardShortcutsInfoButton/KeyboardShortcutsInfoModal/components/BasicShortcutsInfo";
import { VideoShortcutsInfo } from "~/components/AssetModal/Panel/Tabs/KeyboardShortcutsInfoButton/KeyboardShortcutsInfoModal/components/VideoShortcutsInfo";
import { KEYBOARD_SHORTCUTS_MODAL } from "~/constants/testIDs";
import { VideoTimeFormatProvider } from "~/providers/VideoTimeFormatProvider";
import { centralizedClipIdSelector } from "~/store/centralizedClip/selectors";
export const KeyboardShortcutsInfoModal = /*#__PURE__*/ memo((param)=>{
    let { onClose } = param;
    const clipId = useSelector(centralizedClipIdSelector);
    const [activeTab, setActiveTab] = useState("general");
    const panels = useMemo(()=>[
            {
                id: "general",
                label: "General",
                content: /*#__PURE__*/ _jsx(BasicShortcutsInfo, {})
            },
            {
                id: "comments",
                label: "Comments",
                content: /*#__PURE__*/ _jsx(AnnotationsShortcutsInfo, {})
            },
            {
                id: "video",
                label: "Video",
                content: /*#__PURE__*/ _jsx(VideoShortcutsInfo, {})
            }
        ], []);
    const onTabChange = useCallback((value)=>{
        setActiveTab(value);
    }, []);
    return /*#__PURE__*/ _jsx(VideoTimeFormatProvider, {
        clipId: clipId,
        children: /*#__PURE__*/ _jsxs(Modal, {
            "data-testid": KEYBOARD_SHORTCUTS_MODAL,
            isOpen: true,
            onDismiss: onClose,
            dangerouslyBypassFocusLock: true,
            children: [
                /*#__PURE__*/ _jsxs("header", {
                    className: "mb-6 flex items-center justify-between gap-2",
                    children: [
                        /*#__PURE__*/ _jsx(ModalTitle, {
                            children: "Keyboard Shortcuts"
                        }),
                        /*#__PURE__*/ _jsx(ModalCloseButton, {
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Tabs, {
                    className: "-mx-6 -mt-1",
                    defaultValue: panels[0].id,
                    listClassName: "px-6",
                    panels: panels,
                    panelsClassName: "px-6 pt-4",
                    onValueChange: onTabChange,
                    value: activeTab
                })
            ]
        })
    });
});
KeyboardShortcutsInfoModal.displayName = "KeyboardShortcutsInfoModal";
